import { useAuthStore } from '~/stores/auth'

/**
 * 메뉴(라우트) 접속 이력 기록.
 *
 * /base · /biz 영역의 메뉴로 이동할 때마다 백엔드에 접속 경로를 전송하여
 * LogType.MENU 로그를 남긴다. (접속 이력 화면의 '메뉴 접속' 유형)
 *
 * - 클라이언트에서만 동작하며, 네비게이션을 막지 않도록 fire-and-forget 으로 호출한다.
 * - 비로그인 상태에서는 기록하지 않는다(불필요한 401/세션복구 팝업 방지).
 */
export default defineNuxtRouteMiddleware((to) => {
  if (process.server) return
  if (!to.path.startsWith('/base') && !to.path.startsWith('/biz')) return
  if (to.path.startsWith('/base/error/')) return

  const authStore = useAuthStore()
  if (!authStore.accessToken && !authStore.refreshToken) return

  const { $api } = useNuxtApp()
  $api.post('/api/v1/base/system/access-logs/menu-access', { path: to.path })
    .catch(() => { /* 로깅 실패는 무시 */ })
})
